import { render, staticRenderFns } from "./DossierList.vue?vue&type=template&id=449d8201"
import script from "./DossierList.vue?vue&type=script&lang=ts"
export * from "./DossierList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449d8201')) {
      api.createRecord('449d8201', component.options)
    } else {
      api.reload('449d8201', component.options)
    }
    module.hot.accept("./DossierList.vue?vue&type=template&id=449d8201", function () {
      api.rerender('449d8201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/DossierList.vue"
export default component.exports